import LinkModal from "../components/LinkModal";
import { GitMerge } from "react-feather";
import { getVenue } from "../clients/art";

function MergeVenueModal(props) {
  return (
    <LinkModal
      linkRequest={props.linkRequest}
      params={props.params}
      onClose={props.onClose}
      onLink={props.onLink}
      buttonIcon={GitMerge}
      buttonCaption="Merge"
      placeholder="Search venues&hellip;"
      keyName="sourceId"
      nameAttribute="name"
      getRequest={getVenue}
      searchIndex="venues"
      searchTransform={(hit) => ({
        resultType: "venue",
        name: hit.name,
        flavor: hit.subheading || hit.city,
        img: hit.imageUrl,
        id: hit.objectID,
      })}
      resultType="venue"
      title="Merge venue"
      toastMessage="The venue was merged"
      description={
        <p className="small text-muted">
          The venue you select will be deleted. All the events and works will be
          moved to {props.targetName}.
        </p>
      }
    />
  );
}

export default MergeVenueModal;
